import axios from "axios";
import { CreatePromptPayload, LLMAgentPayload, LLMCreateRAGPayload, UpdatePromptPayload } from "types/prompt.types";
import { LLM_BASE_URL, LLM_PASSWORD, LLM_USERNAME } from "utils/constant";
import { LLMAgentConversationRetrivalPayload, LLMAgentImageCreatePayload, LLMAgentInstructPayload, LLMAgentRAGCreatePayload, LLMAgentRAGDeletePayload, LLMAgentRAGUpdatePayload } from "./payloads";

const getLLMAxiosConfig = () => {
    return {}
    // const basicAuth = 'Basic ' + btoa(LLM_USERNAME + ':' + LLM_PASSWORD);
    // return {
    //     headers: {
    //         'Authorization': basicAuth,
    //         'Content-Type': 'application/json'
    //     }
    // }
}

export const llmCreateRAG = async (payload: LLMAgentRAGCreatePayload) => {
    try {
        return await axios.post(
            `${LLM_BASE_URL}/feteboard/llm/agent/rag/create/v1`,
            payload,
            getLLMAxiosConfig()
        );
    } catch (error) {
        throw error;
    }
};

export const llmAgentConversation = async (payload: LLMAgentPayload) => {
    try {
        return await axios.post(
            `${LLM_BASE_URL}/feteboard/llm/agent/conversation/v1`,
            payload,
            getLLMAxiosConfig()
        );
    } catch (error) {
        throw error;
    }
};

export const llmAgentConversationRetrival = async (payload: LLMAgentConversationRetrivalPayload) => {
    try {
        return await axios.post(
            `${LLM_BASE_URL}/feteboard/llm/agent/conversation_retrival/v1`,
            payload,
            getLLMAxiosConfig()
        );
    } catch (error) {
        throw error;
    }
};

export const llmAgentQA = async (payload: LLMAgentPayload) => {
    try {
        return await axios.post(
            `${LLM_BASE_URL}/feteboard/llm/agent/qa/v1`,
            payload,
            getLLMAxiosConfig()
        );
    } catch (error) {
        throw error;
    }
};

export const llmAgentInstruction = async (payload: LLMAgentInstructPayload) => {
    try {
        return await axios.post(
            `${LLM_BASE_URL}/feteboard/llm/agent/instruction/v1`,
            payload,
            getLLMAxiosConfig()
        );
    } catch (error) {
        throw error;
    }
};

export const searchPrompts = async (query?: string) => {
    try {
        return await axios.get(
            `${LLM_BASE_URL}/feteboard/llm/prompt-template/search/v1${query ? '?query' + query : ''}`,
            getLLMAxiosConfig()
        );
    } catch (error) {
        throw error;
    }
}
export const createPrompt = async (payload: CreatePromptPayload) => {
    try {
        return await axios.post(
            `${LLM_BASE_URL}/feteboard/llm/prompt-template/create/v1`,
            payload,
            getLLMAxiosConfig()
        );
    } catch (error) {
        throw error;
    }
}

export const updatePrompt = async (id: string, payload: UpdatePromptPayload) => {
    try {
        return await axios.put(
            `${LLM_BASE_URL}/feteboard/llm/prompt-template/update/${id}/v1`,
            payload,
            getLLMAxiosConfig()
        );
    } catch (error) {
        throw error;
    }
}

export const getChatHistory = async (session_id: string) => {
    try {
        return await axios.get(
            `${LLM_BASE_URL}/feteboard/llm/agent/chat_history/v1?session_id=${session_id}`,
            getLLMAxiosConfig()
        );
    } catch (error) {
        throw error;
    }
}

export const generateImage = async (payload: LLMAgentImageCreatePayload) => {
    try {
        return await axios.post(
            `${LLM_BASE_URL}/feteboard/llm/agent/image/create/v1`,
            payload,
            getLLMAxiosConfig()
        );
    } catch (error) {
        throw error;
    }
}

export const llmUpdateRAG = async (payload: LLMAgentRAGUpdatePayload) => {
    try {
        return await axios.post(
            `${LLM_BASE_URL}/feteboard/llm/agent/rag/update/v1`,
            payload,
            getLLMAxiosConfig()
        );
    } catch (error) {
        throw error;
    }
};

export const llmDeleteRAG = async (payload: LLMAgentRAGDeletePayload) => {
    try {
        return await axios.delete(
            `${LLM_BASE_URL}/feteboard/llm/agent/rag/delete/${payload.index_name}/v1?document_name=${payload.document_id}`,
            getLLMAxiosConfig()
        );
    } catch (error) {
        throw error;
    }
};